/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('shared').filter('formatTextDate', ['dateService', dateService =>
  function(rawDate) {
    if (rawDate) { return dateService.formatDate(rawDate, dateService.getTextFormat()); }
  }
]);
